var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qx-card-form',{attrs:{"title":"收款信息"}},[_c('qx-custom-form',{ref:"baseForm",attrs:{"noSubBtn":true,"formData":_vm.baseForm,"labelWidth":"120px"},scopedSlots:_vm._u([{key:"receiver",fn:function(prop){return _c('section',{},[_c('ChooseReceiver',{ref:"chooseReceiver",attrs:{"isRadio":true,"otherSearchData":{
          billId: _vm.billId,
          userType: _vm.userType,
        },"fnRadioDisabled":function (item) {
            var disabled = false;
            if (_vm.$route.query.vehicleFeeType === '1') {
              if (item.userType !== 1) {
                disabled = true;
              }
            }
            if (_vm.$route.query.vehicleFeeType === '2') {
              if (item.userType !== 3) {
                disabled = true;
              }
            }
            return disabled;
          }},on:{"change":_vm.handleReceiverChange},model:{value:(prop.form.receiver),callback:function ($$v) {_vm.$set(prop.form, "receiver", $$v)},expression:"prop.form.receiver"}})],1)}},{key:"selectedLIds",fn:function(prop){return _c('section',{},[_c('ChooseDeduct',{attrs:{"acUserId":_vm.acUserId},on:{"change":_vm.handleDeductChange},model:{value:(prop.form.selectedLIds),callback:function ($$v) {_vm.$set(prop.form, "selectedLIds", $$v)},expression:"prop.form.selectedLIds"}})],1)}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }